import Image from 'next/image'

import { cn } from '@/utils/cn'

type Props = {
  name: string
  avatarUrl: string
  isPioneer: boolean
  size?: number
}

function Avatar(props: Props) {
  const { name, avatarUrl, isPioneer, size } = props
  return (
    <Image
      src={avatarUrl}
      alt={name}
      width={size}
      height={size}
      className={cn(
        'rounded-full',
        isPioneer
          ? 'border-1 border-transparent bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500 p-[2px]'
          : 'border-1 border-gray-700'
      )}
    />
  )
}

export default Avatar